module.exports = __webpack_public_path__ + "img/view3d-notice-3.f159a4b4.png";